function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useContext, useEffect, useState } from 'react';
import { AppBar, Box, Container, Divider, Grid2 as Grid, Stack, Toolbar, Typography, Link } from '@mui/material';
import { LogoAndProductName } from '../components';
import { constants } from '../constants';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../components/ConfigContext';
import { AuthorizationAPI, SettingsAPI } from '../apis';
import { handleErrorModal } from '../components/Toast';
import { v4 as uuidv4 } from 'uuid';
import LoadingButton from '@mui/lab/LoadingButton';
import Cookies from 'js-cookie';
import { decodeAccessToken, setPolicies } from '../utils/auth';
var Home = function Home() {
    var router = useNavigate();
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isLogin = _useState2[0], setIsLogin = _useState2[1];
    var loginURL = process.env.REACT_APP_API_URL + '/authentication/loginRedirect';
    var _useContext = useContext(ConfigContext), configState = _useContext.configState, setConfigState = _useContext.setConfigState;
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), loader = _useState4[0], setLoader = _useState4[1];
    var _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), envProduct = _useState6[0], setEnvProduct = _useState6[1];
    useEffect(function () {
        var product = '';
        if (process.env.REACT_APP_PRODUCTS) {
            var _process$env$REACT_AP;
            product = (_process$env$REACT_AP = process.env.REACT_APP_PRODUCTS) === null || _process$env$REACT_AP === void 0 ? void 0 : _process$env$REACT_AP.split(',')[0];
        }
        setEnvProduct(product);
    }, [process.env.REACT_APP_PRODUCTS]);
    useEffect(function () {
        var fetchData = /*#__PURE__*/ function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.n) {
                            case 0:
                                _context.n = 1;
                                return Promise.all([getSettings(), getPageImage(), getHeaderImage()]);
                            case 1:
                                return _context.a(2);
                        }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var getSettings = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return SettingsAPI.getSettings().then(function (response) {
                                setConfigState(function (prevState) {
                                    return _objectSpread(_objectSpread({}, prevState), {}, {
                                        settings: _objectSpread(_objectSpread({}, prevState.settings), response)
                                    });
                                });
                            });
                        case 1:
                            return _context2.a(2);
                    }
            }, _callee2);
        }));
        return function getSettings() {
            return _ref2.apply(this, arguments);
        };
    }();
    var getPageImage = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return SettingsAPI.getSettingsImage('theme', 'image').then(function (response) {
                                setConfigState(function (prevState) {
                                    return _objectSpread(_objectSpread({}, prevState), {}, {
                                        settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                            page_image: response
                                        })
                                    });
                                });
                            });
                        case 1:
                            return _context3.a(2);
                    }
            }, _callee3);
        }));
        return function getPageImage() {
            return _ref3.apply(this, arguments);
        };
    }();
    var getHeaderImage = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            _context4.n = 1;
                            return SettingsAPI.getSettingsImage('theme', 'logo').then(function (response) {
                                setConfigState(function (prevState) {
                                    return _objectSpread(_objectSpread({}, prevState), {}, {
                                        settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                            header_logo_image: response
                                        })
                                    });
                                });
                            });
                        case 1:
                            return _context4.a(2);
                    }
            }, _callee4);
        }));
        return function getHeaderImage() {
            return _ref4.apply(this, arguments);
        };
    }();
    useEffect(function () {
        if (isLogin) {
            var _process$env$REACT_AP2;
            if (JSON.parse((_process$env$REACT_AP2 = process.env.REACT_APP_false) !== null && _process$env$REACT_AP2 !== void 0 ? _process$env$REACT_AP2 : 'false')) {
                // Redirect to product selection page
                router('/productSelection');
            }
            else {
                var _process$env$REACT_AP3;
                // Original logic - redirect to first product
                var product = ((_process$env$REACT_AP3 = process.env.REACT_APP_PRODUCTS) === null || _process$env$REACT_AP3 === void 0 ? void 0 : _process$env$REACT_AP3.split(',')[0]) || '';
                var temp = JSON.parse(JSON.stringify(configState));
                temp.selectedProduct = product;
                setConfigState(temp);
                Cookies.set('Product Selected', product, {
                    secure: true,
                    sameSite: 'Strict'
                });
                router("/".concat(product));
            }
        }
        else {
            getToken();
        }
    }, [isLogin]);
    function getToken() {
        return _getToken.apply(this, arguments);
    }
    function _getToken() {
        _getToken = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7() {
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.n) {
                        case 0:
                            setLoader(true);
                            _context7.n = 1;
                            return AuthorizationAPI.getToken().then(function (result) {
                                if (result !== null && result !== void 0 && result.accessToken) {
                                    Cookies.set('access_token', result.accessToken, {
                                        secure: true,
                                        sameSite: 'Strict'
                                    });
                                    Cookies.set('refresh_token', result.refreshToken, {
                                        secure: true,
                                        sameSite: 'Strict'
                                    });
                                    Cookies.set('ui_trace_id', uuidv4().replaceAll('-', ''), {
                                        secure: true,
                                        sameSite: 'Strict'
                                    });
                                    getUser();
                                }
                                else {
                                    setLoader(false);
                                }
                            })["catch"](function () {
                                setLoader(false);
                            });
                        case 1:
                            return _context7.a(2);
                    }
            }, _callee7);
        }));
        return _getToken.apply(this, arguments);
    }
    var getUser = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var userName;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.n) {
                        case 0:
                            setLoader(true);
                            if (Cookies.get('access_token')) {
                                _context5.n = 1;
                                break;
                            }
                            setLoader(false);
                            handleErrorModal(true, 'Access token not found');
                            return _context5.a(2);
                        case 1:
                            userName = decodeAccessToken(Cookies.get('access_token'));
                            if (userName) {
                                _context5.n = 2;
                                break;
                            }
                            setLoader(false);
                            handleErrorModal(true, 'User Name not found');
                            return _context5.a(2);
                        case 2:
                            _context5.n = 3;
                            return AuthorizationAPI.getUser(userName).then(function (response) {
                                var _process$env$REACT_AP4;
                                var user = response.resource.find(function (item) {
                                    return item.username === userName;
                                });
                                Cookies.set('user', JSON.stringify(user), {
                                    secure: true,
                                    sameSite: 'Strict'
                                });
                                setConfigState(_objectSpread(_objectSpread({}, configState), {}, {
                                    selectedProduct: ((_process$env$REACT_AP4 = process.env.REACT_APP_PRODUCTS) === null || _process$env$REACT_AP4 === void 0 ? void 0 : _process$env$REACT_AP4.split(',')[0]) || ''
                                }));
                                getPolicy();
                            })["catch"](function () {
                                setLoader(false);
                            });
                        case 3:
                            return _context5.a(2);
                    }
            }, _callee5);
        }));
        return function getUser() {
            return _ref5.apply(this, arguments);
        };
    }();
    var RedirectToLogin = function RedirectToLogin() {
        if (typeof window !== 'undefined') {
            window.location.replace(loginURL);
        }
    };
    var getPolicy = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6() {
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.n) {
                        case 0:
                            setLoader(true);
                            _context6.n = 1;
                            return setPolicies();
                        case 1:
                            setIsLogin(true);
                            setLoader(false);
                        case 2:
                            return _context6.a(2);
                    }
            }, _callee6);
        }));
        return function getPolicy() {
            return _ref6.apply(this, arguments);
        };
    }();
    var getCookiePrivacyButtons = function getCookiePrivacyButtons() {
        var isNewDesign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var textColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#FFFFFF';
        return /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            spacing: 2.5,
            sx: {
                mt: 3,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Link, {
            href: process.env.REACT_APP_https://resources.deloitte.com/sites/US/system/Pages/DeloitteNet_Web_Privacy_statement.aspx,
            target: "_blank",
            rel: "noopener noreferrer",
            underline: "none",
            sx: _objectSpread({
                color: textColor
            }, isNewDesign && {
                fontFamily: 'Open Sans',
                fontSize: '16px',
                fontWeight: 400,
                textTransform: 'none',
                mr: 3
            })
        }, constants.privacy), /*#__PURE__*/ React.createElement(Divider, {
            orientation: "vertical",
            sx: {
                border: "1px solid ".concat(textColor),
                height: '20px',
                mt: '7px !important'
            },
            flexItem: true
        }), /*#__PURE__*/ React.createElement(Link, {
            href: process.env.REACT_APP_https://cookienotice.deloitte.com,
            target: "_blank",
            rel: "noopener noreferrer",
            underline: "none",
            sx: _objectSpread({
                color: textColor
            }, isNewDesign && {
                fontFamily: 'Open Sans',
                fontSize: '16px',
                fontWeight: 400,
                textTransform: 'none'
            })
        }, constants.cookies));
    };
    var getDefaultLoginPage = function getDefaultLoginPage() {
        var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4, _process$env$REACT_AP5, _configState$settings5, _configState$settings6, _configState$settings7, _configState$settings8, _configState$settings9, _configState$settings0, _configState$settings1, _configState$settings10, _configState$settings11, _configState$settings12;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AppBar, {
            sx: {
                background: configState !== null && configState !== void 0 && (_configState$settings = configState.settings) !== null && _configState$settings !== void 0 && _configState$settings.background_color ? "".concat(configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.background_color) : '#FFFFFF',
                minHeight: '100vh',
                maxHeight: '100vh',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ React.createElement(AppBar, {
            position: "fixed",
            sx: {
                background: configState !== null && configState !== void 0 && (_configState$settings3 = configState.settings) !== null && _configState$settings3 !== void 0 && _configState$settings3.background_color ? "".concat(configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.background_color) : '#FFFFFF',
                zIndex: 1200,
                boxShadow: 'none',
                height: 64
            }
        }, /*#__PURE__*/ React.createElement(Toolbar, null, /*#__PURE__*/ React.createElement(LogoAndProductName, {
            application: (_process$env$REACT_AP5 = process.env.REACT_APP_NAME) === null || _process$env$REACT_AP5 === void 0 ? void 0 : _process$env$REACT_AP5.split(',')[0]
        }))), /*#__PURE__*/ React.createElement(Container, {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'calc(100vh - 128px)',
                maxHeight: 'calc(100vh - 128px)',
                mt: 8,
                mb: 7,
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            sx: {
                height: '100%',
                width: '100%',
                maxHeight: '100%',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            size: 5,
            sx: {
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex'
            }
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "column",
            sx: {
                width: '70%',
                display: 'flex',
                alignItems: 'start'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            sx: {
                marginTop: '48px',
                marginBottom: '48px'
            },
            color: configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.welcome_message_color,
            fontWeight: 700
        }, "Welcome to ", /*#__PURE__*/ React.createElement("br", null), (_configState$settings6 = configState === null || configState === void 0 || (_configState$settings7 = configState.settings) === null || _configState$settings7 === void 0 ? void 0 : _configState$settings7.workspace_name) !== null && _configState$settings6 !== void 0 ? _configState$settings6 : ''), /*#__PURE__*/ React.createElement(LoadingButton, {
            variant: "contained",
            size: "large",
            sx: {
                textTransform: 'none',
                borderColor: "1px solid ".concat(configState === null || configState === void 0 || (_configState$settings8 = configState.settings) === null || _configState$settings8 === void 0 ? void 0 : _configState$settings8.button_color, " !important"),
                backgroundColor: "".concat(configState === null || configState === void 0 || (_configState$settings9 = configState.settings) === null || _configState$settings9 === void 0 ? void 0 : _configState$settings9.button_color, " !important"),
                color: "".concat(configState === null || configState === void 0 || (_configState$settings0 = configState.settings) === null || _configState$settings0 === void 0 ? void 0 : _configState$settings0.button_text_color, " !important"),
                '&:hover': {
                    backgroundColor: configState === null || configState === void 0 || (_configState$settings1 = configState.settings) === null || _configState$settings1 === void 0 ? void 0 : _configState$settings1.button_color,
                    borderColor: configState === null || configState === void 0 || (_configState$settings10 = configState.settings) === null || _configState$settings10 === void 0 ? void 0 : _configState$settings10.button_color,
                    color: "".concat(configState === null || configState === void 0 || (_configState$settings11 = configState.settings) === null || _configState$settings11 === void 0 ? void 0 : _configState$settings11.button_text_color, " !important"),
                    cursor: 'pointer'
                }
            },
            onClick: function onClick(e) {
                e.preventDefault();
                e.stopPropagation();
                RedirectToLogin();
            },
            "data-testid": "login_button",
            loading: loader
        }, loader ? /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                color: 'white',
                fontFamily: 'Roboto',
                fontSize: 15,
                fontWeight: 600,
                letterSpacing: 0.46
            }
        }, "Loading...") : /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            fontWeight: 700
        }, constants.Login_button)), getCookiePrivacyButtons(true, '#595959'))), /*#__PURE__*/ React.createElement(Grid, {
            size: 7,
            sx: {
                justifyContent: 'right',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '100%',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            component: "div",
            sx: {
                height: '80vh',
                width: '100%',
                maxWidth: '100%',
                maxHeight: '80vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            component: "div",
            dangerouslySetInnerHTML: {
                __html: configState === null || configState === void 0 || (_configState$settings12 = configState.settings) === null || _configState$settings12 === void 0 ? void 0 : _configState$settings12.page_image
            },
            sx: {
                height: '100%',
                width: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                '& svg': {
                    height: '80vh !important',
                    width: '100% !important',
                    maxWidth: '100% !important',
                    maxHeight: '80vh !important',
                    display: 'block',
                    objectFit: 'contain'
                },
                '& img': {
                    height: '80vh',
                    width: '100%',
                    maxWidth: '100%',
                    maxHeight: '80vh',
                    objectFit: 'contain'
                }
            }
        })))))), /*#__PURE__*/ React.createElement(Box, {
            component: "footer",
            sx: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1200,
                background: '#f8f8f8',
                padding: '16px'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                marginRight: '8px'
            }
        }, constants.Copyright_text3), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                marginRight: '8px'
            }
        }, "|"), /*#__PURE__*/ React.createElement(Typography, null, constants.Copyright_text1 + new Date().getFullYear() + constants.Copyright_text2)), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                height: '80px',
                backgroundColor: 'transparent'
            }
        }));
    };
    var getLoginPage = function getLoginPage() {
        if (envProduct == '') {
            return /*#__PURE__*/ React.createElement("div", null);
        }
        return getDefaultLoginPage();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, getLoginPage());
};
export default Home;
